import {
  API,
  CustomOptions,
  INextError,
  LoggerInstance,
  vmsClient,
} from '@vfit/shared/data-access';
import { IPartnershipValidatePayload, IPartnershipValidateResponse } from './validate.models';
import { useMutation, useQueryClient } from 'react-query';

const partnershipValidateVMSService = (
  payload: IPartnershipValidatePayload,
  customOptions?: CustomOptions
) =>
  vmsClient.post(API.VMS_PARTNERSHIP_VALIDATE, payload, {
    ...(customOptions?.headers && { headers: customOptions.headers }),
    ...(customOptions?.ignoreUpdateToken && { ignoreUpdateToken: true }),
    ...(customOptions?.silentLoginHeaders && {
      silentLoginHeaders: customOptions.silentLoginHeaders,
    }),
  }) as Promise<IPartnershipValidateResponse>;

export const usePartnershipVMSValidate = (customOptions?: CustomOptions) => {
  const queryClient = useQueryClient();
  return useMutation(
    'partnershipValidate',
    (payload: IPartnershipValidatePayload) => {
      return partnershipValidateVMSService(payload, customOptions);
    },
    {
      onSuccess: (data: IPartnershipValidateResponse) => {
        localStorage.setItem('partnershipValidate', JSON.stringify(data));
        queryClient.setQueryData('partnershipValidate', data);
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR on partnershipValidate: `, error);
        localStorage.setItem(`partnershipValidate`, JSON.stringify(error));
      },
    }
  );
};

